<template>
    <div class="peribox">
        <div class="perititle">
            <div>Lead Job</div>
            <div class="periicons">
                <i class="far fa-sync-alt" @click="refresh"></i>
            </div>
        </div>
        <table class="peritable">
            <tbody>
            <tr>
                <th v-for="c in appJobColumns">{{ c }}</th>
            </tr>
            <tr v-for="row in applicationJobs">
                <td v-for="c in appJobColumns">{{ row ? row[c] : '' }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'app_id'
    ],
    data() {
        let appJobColumns = [
            'id',
            'application_id',
            'employer_id',
            'campaign_id',
            'job_id',
            'budget_period_id',
            'budget_order_id',
            'should_deliver',
            'should_charge',
            'is_client_visible',
            'is_accounts_visible',
            'is_duplicate',
            'price',
            'referrer',
            'referrer_append',
            'p1_bonus',
            'p2_bonus',
            'rules_fired'
        ];

        return {
            applicationJobs: [],
            appJobColumns: appJobColumns
        };
    },
    methods: {
        refresh() {
            axios.get(url(`app/test/app/${this.app_id}`))
                .then((response) => {
                    this.applicationJobs = response.data.applicationJobs;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>
